import Component from './virtual-tour';

export default Component;